var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main_container"},[_c('Header'),_c('div',{staticStyle:{"flex":"1","overflow":"auto"}},[_c('router-view')],1),_c('Footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }